import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { ApiConsumes, ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { WhatsappService } from './whatsapp.service';
import { GrpStatuUpdateDto, MsgDTO, WhatsAppSetngDto } from './dto/whatsapp.dto';
import { AllSettingsResponseModel, SingleResponseModel } from './dto/whatsapp-response-model';
import { FilesInterceptor } from '@nestjs/platform-express';
import { diskStorage } from 'multer';
import { extname } from 'path';

@ApiTags('WhatsApp')
@Controller('whatsapp')


export class WhatsappController {
    constructor (
        private wappServ: WhatsappService,
    ){}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getAppSettings')
    @ApiQuery({name:'apiVersion'})
    async getAppSettings(@Query() queryParams, @Req() request:Request):Promise<AllSettingsResponseModel> {
        try {           
            return await this.wappServ.getAppSettings(queryParams,request);
        } catch (error) {
            return errorHandler(AllSettingsResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/changeAppSettings') 
    @ApiQuery({name:'apiVersion'})   
    async changeAppSettings(@Query() queryParam,@Body() waDto:WhatsAppSetngDto,@Req() request:Request): Promise<SingleResponseModel> {
        try {
            return await this.wappServ.changeAppSettings(queryParam, waDto, request);
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/saveWhatsAppGroupsFromAPP')
    @ApiQuery({name:'apiVersion'})
    async saveWhatsAppGroupsFromAPP(@Query() queryParams, @Req() request:Request):Promise<AllSettingsResponseModel> {
        try {           
            return await this.wappServ.saveWhatsAppGroupsFromAPP(queryParams,request);
        } catch (error) {
            return errorHandler(AllSettingsResponseModel, error);
        }
    }



    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getWhatsAppGroups')
    @ApiQuery({name:'apiVersion'})
    async getWhatsAppGroups(@Query() queryParams, @Req() request:Request):Promise<AllSettingsResponseModel> {
        try {           
            return await this.wappServ.getWhatsAppGroups(queryParams,request);
        } catch (error) {
            return errorHandler(AllSettingsResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/changeWhatsAppGroupsStatus') 
    @ApiQuery({name:'apiVersion'})   
    async changeWhatsAppGroupsStatus(@Query() queryParam,@Body() waDto:GrpStatuUpdateDto,@Req() request:Request): Promise<SingleResponseModel> {
        try {
            return await this.wappServ.changeWhatsAppGroupsStatus(queryParam, waDto, request);
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getWhatsAppMobileNos')
    @ApiQuery({name:'apiVersion'})
    async getWhatsAppMobileNos(@Query() queryParams, @Req() request:Request):Promise<AllSettingsResponseModel> {
        try {           
            return await this.wappServ.getWhatsAppMobileNos(queryParams,request);
        } catch (error) {
            return errorHandler(AllSettingsResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Post('/sendmsg')
    @ApiOperation({summary:'Types: 1 - text/url, 2 - Image, 3 - Video'})  
    @ApiQuery({name:'apiVersion'})  
    @UseInterceptors(
		FilesInterceptor('attachments', 1, {
			//fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/msgFiles',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async sendmsg(@Query() queryParam,@UploadedFiles() attachments,@Body() postDto:MsgDTO,@Req() request:Request): Promise<SingleResponseModel> {
        try {
            if(postDto.TypeId == 1) { //text/url post
                return await this.wappServ.sendtxtmsg(queryParam,postDto,request);
            } else {                
                if(postDto.TypeId == 2 || postDto.TypeId == 3) { // 2 image post, 3 video post   
                    let imgpath = '';                 
                    attachments.forEach(file => {
                        imgpath = `whatsapp/msgFiles/${file.filename}`;                        
                    })
                    return await this.wappServ.sendimgvidmsg(queryParam, imgpath, postDto);
                } 
            }
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }

    @Get('/msgFiles/:imgpath')
    @ApiParam({name:'imgpath'})
    seeUploadedFile(@Param('imgpath') Image, @Res() res) {
		try {
			return res.sendFile(Image, { root: './public/msgFiles' });
		} catch (error) {
			return error.message;
		}
	}
}